export default __webpack_public_path__ + "static/media/CronosMarines.f9b497e9.png";